import { Pipe, PipeTransform } from "@angular/core";
import * as _ from 'lodash';
import { PrescriptionsModel } from "../models/history.model";

@Pipe({ name: 'prescription' })
export class PrescriptionPipe implements PipeTransform {
    transform(array: PrescriptionsModel[], codes: any[]) {
        let result: PrescriptionsModel[] = [];
        result.push(...array);

        if (codes && codes.length > 0) {
            let by_code = []
            by_code.push(..._.filter(result, row => codes.some(t => t === row.product_name)));
            return by_code.sort((a, b) => (this.parseToTime1(a.drug_note_date) < this.parseToTime1(b.drug_note_date)) ? -1 : 1);
        }

        return result.sort((a, b) => (this.parseToTime1(a.drug_note_date) < this.parseToTime1(b.drug_note_date)) ? -1 : 1);
    }

    parseToTime1(date: string) {
        let split = date.split('/');
        if (split) {
            let date = new Date(Number(split[2]), Number(split[0]) - 1, Number(split[1]));
            return date.getTime()
        }
        return 0;
    }
}